import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export const GetAgentStatsServices = (token) =>{
  return new Promise(async (resolve, reject) => {
    try {
  
      const response = await axios.get(`${URL_AUTH}/api/admin/v1/agent-stats`, {
        headers: {
          "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          Authorization: `Bearer ${token}`,
        },
      });
      resolve(response);
      console.log(response);
    } catch (error) {
      reject(error);
      console.log(error);
    }
  });
}